/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { setParticipants } from "../store/slice/roomSlice";
import { deleteRoom, leaveRoom } from "../multiplayer/SocketConnection";
import * as webRTCHandler from "../handlers/webRTCHandler"
import store from "../store/store";

export const handleParticipantLeftRoom = (disconnUserSocketId) => {
    const stillConnectedUser = store.getState().room.participants
        .filter(participant => {
            return participant.socketId !== disconnUserSocketId
        })

    if (store.getState().room.configuredStunServer)
        webRTCHandler.closeWebRTCConnection(disconnUserSocketId);

    store.dispatch(setParticipants(stillConnectedUser));
}

export const handleLogout = () => {
    const state = store.getState()

    const roomId = state.room.roomId
    const currentUserSocketId = state.user.data.socketId;
    const isOwner = state.room.roomCreator?.socketId === currentUserSocketId

    if (store.getState().room.configuredStunServer)
        webRTCHandler.closeAllWebRTCConnections();

    const data = {
        roomId,
        participantSocketId: currentUserSocketId,
    }

    if (roomId) {
        if (isOwner)
            deleteRoom(roomId)
        else
            leaveRoom(data)
    }

    localStorage.clear();
    window.location.pathname = "/login";
}